import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatchingContainerComponent } from './components/matching-container/matching-container.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';

const routes: Routes = [
  {
    path: '',
    component:MatchingContainerComponent,
  
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MatchingRoutingModule { }
